import { cn } from "@omni/utils/styles";
import { useCallback, useEffect } from "react";

import { useStoreServiceApi } from "@/api/hooks/storeService.hook";
import { EcornerService } from "@/services/eCorner.service";

import { ProductFacing } from "./productFacing.component";

type Props = {
    sku: string;
    className?: string;
};

const ProductFacingContainer = ({ sku, className }: Props) => {
    const [{ data, loading, error }, get] = useStoreServiceApi(
        {
            method: "GET"
        },
        {
            manual: true
        }
    );

    const getProductFacing = useCallback(async () => {
        if (!(await EcornerService.isEcornerEnvironment())) return;

        const { url, urlParams } = await EcornerService.getEcornerUrl(sku);

        if (url && urlParams) {
            get({
                url,
                urlParams
            });
        }
    }, [sku, get]);

    useEffect(() => {
        if (data) return;
        if (loading) return;
        if (error) return;

        getProductFacing();
    }, [data, loading, error, getProductFacing]);

    if (!data) {
        return null;
    }

    return (
        <ProductFacing
            layer={data.layer}
            subFacingName={data.subFacingName}
            name={data.name}
            position={data.position}
            amountOfPositions={data.amountOfPositions}
            className={cn(className)}
        />
    );
};

export { ProductFacingContainer };
